module.exports = __webpack_public_path__ + "img/video_setting.241ae401.png";